import { FetchArgs } from '@reduxjs/toolkit/query';
import React from 'react';

import { Label } from '@eika/label';

import { getErrorData } from '@/functions/get-error-data';

interface DetailProps {
    children?: string | number;
    label: string;
}

const Details = ({ label, children }: DetailProps) => {
    if (typeof children === 'undefined') {
        return null;
    }

    return (
        <span>
            <Label text={`${label}:`} /> <pre>{children}</pre>
        </span>
    );
};

interface FetchErrorProps {
    message: string;
    error: Error | null;
    args?: string | FetchArgs;
}

const FetchError = ({ message, error, args }: FetchErrorProps) => {
    const { title, detail, status } = getErrorData(error);

    return (
        <>
            <Label text={message} />
            <Details label="Årsak">{title}</Details>
            {typeof args === 'undefined' ? null : (
                <Details label="URL">{typeof args === 'string' ? args : args.url}</Details>
            )}
            <Details label="Statuskode">{status}</Details>
            {title === detail ? null : <Details label="Detaljer">{detail}</Details>}
        </>
    );
};

export default FetchError;
